const UnknownMaterialCharsFieldConfig = [];

export default UnknownMaterialCharsFieldConfig;
